// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import { PageModel } from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import PageWithMobileOverFlow from "@store/Library/Components/Reporting/Common/PageWithMobileOverFlow";
import React from "react";

const MonthlyExpenseComparison = ({ id }: PageModel) => {
    return (
        <PageWithMobileOverFlow>
            <Zone contentId={id} zoneName="Content"></Zone>
            <Modals />
        </PageWithMobileOverFlow>
    );
};

const pageModule = {
    component: MonthlyExpenseComparison,

    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};
export default pageModule;
